import { render } from "./MainContentBanner.vue?vue&type=template&id=054488f5&scoped=true"
import script from "./MainContentBanner.vue?vue&type=script&lang=js"
export * from "./MainContentBanner.vue?vue&type=script&lang=js"

import "./MainContentBanner.vue?vue&type=style&index=0&id=054488f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054488f5"]])

export default __exports__